import { Icon } from '../../Services/constant/serviceType';

export const NavInspectionIcon = ({ size, color }: Icon) => {
  return (
    <>
      <svg width={size} height={size} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M16.125 12.3594V7.10938H1.875V15.3594C1.875 15.5583 1.95402 15.7491 2.09467 15.8897C2.23532 16.0304 2.42609 16.1094 2.625 16.1094H9"
          stroke={color} stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        <path
          d="M1.875 3.73438C1.875 3.53546 1.95402 3.3447 2.09467 3.20405C2.23532 3.06339 2.42609 2.98437 2.625 2.98438H15.375C15.5739 2.98438 15.7647 3.06339 15.9053 3.20405C16.046 3.3447 16.125 3.53546 16.125 3.73438V7.10938H1.875V3.73438Z"
          stroke={color} stroke-width="2" stroke-linejoin="round" />
        <path d="M6 1.85938V4.85938M12 1.85938V4.85938" stroke={color} stroke-width="2" stroke-linecap="round" />
        <path
          d="M11.25 14.6094C12.6997 14.6094 13.875 13.4341 13.875 11.9844C13.875 10.5346 12.6997 9.35938 11.25 9.35938C9.80025 9.35938 8.625 10.5346 8.625 11.9844C8.625 13.4341 9.80025 14.6094 11.25 14.6094Z"
          fill={color} stroke={color} stroke-width="2" />
        <path d="M13.5 13.8594L15.75 15.7344" stroke={color} stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round" />
      </svg>


    </>
  );
};
